module.exports = __webpack_public_path__ + "static/media/vip-month.10b699e8.png";